import "react-day-picker/lib/style.css";

import { FormGroup, InputGroup } from "react-bootstrap";
import MomentLocaleUtils, {
  formatDate,
  parseDate
} from "react-day-picker/moment";
import React, { Component } from "react";

import DayPicker from "react-day-picker/DayPicker";
import DayPickerInput from "react-day-picker/DayPickerInput";
import moment from "moment";

class DateRangePicker extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => {
    return {
      from: this.props.from || "",
      to: this.props.to || "",
      enteredTo: null
    };
  };

  isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && DayPicker.DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  };

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("61 - getDerivedStateFromProps", props, state);

    let newState = {};
    if (props.from !== state.from) {
      newState.from = props.from;
    }
    if (props.to !== state.to) {
      newState.to = props.to;
    }
    if (newState.from || newState.to) {
      return newState;
    }
  };

  // componentDidUpdate(prevProps) {
  //   console.log("DateRangePicker.componentDidUpdate", this.props, prevProps);
  //   let newState = {};
  //   if (this.props.from !== this.state.from) {
  //     newState.from = this.props.from;
  //   }
  //   if (this.props.to !== this.state.to) {
  //     newState.to = this.props.to;
  //   }
  //   if (newState.from || newState.to) {
  //     this.setState(newState);
  //   }
  // }

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
  };
  // componentDidMount() {
  //   this.props.onChange(this.state);
  // }
  // focusTo = value => {
  //   this.timeout = setTimeout(() => this.to.getInput().focus(), 0);
  // };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  handleFromChange = from => {
    // Change the from date and focus the "to" input field
    // this.setState({ from }, () => {
    this.setState({from});
    if (!this.state.to) {
      // this.focusTo();
    } else {
      if (!!from) {        
        this.props.handleRangeChange({ from, to: this.state.to });        
      }
    }
    // });
  };
  handleToChange = to => {
    this.setState({ to }, this.showFromMonth);
    if (!!to) {
      this.props.handleRangeChange({ from: this.state.from, to });
    }
  };
  clearFields = () => {
    this.setState(this.getInitialState());

    this.props.handleRangeChange({ from: "", to: "" });
  };
  render = () => {
    const { from, to } = this.state;
    console.log("this.state", this.state);
    const modifiers = { start: from, end: to };
    console.log("modifiers", modifiers);
    return (
      <React.Fragment>
        <div
          className={` Selectable InputFromTo relative ${
            this.props.small ? "height-30" : ""
          }`}
        >
          <FormGroup>
            <InputGroup className="mb-3">
              <DayPickerInput
                value={from}
                placeholder="From"
                format="L"
                formatDate={formatDate}
                parseDate={parseDate}
                keepFocus={true}
                inputProps={{
                  onFocus: e => e.target.select()
                }}
                dayPickerProps={{
                  // className: "Selectable",
                  selectedDays: [from, { from, to }],
                  disabledDays: { after: to },
                  toMonth: to || null,
                  modifiers,
                  numberOfMonths: 2,
                  localeUtils: MomentLocaleUtils,
                  locale: this.props.locale,
                  canChangeMonth: true,
                  showWeekNumbers: true,
                  onDayClick: () => this.to.getInput().focus()
                }}
                onDayChange={this.handleFromChange}
              />
              <InputGroup.Addon>
                <i className="fa fa-calendar" aria-hidden="true" />
              </InputGroup.Addon>{" "}
            </InputGroup>
          </FormGroup>

          <span className="Selectable InputFromTo-to ">
            <FormGroup>
              <InputGroup className="mb-3">
                <DayPickerInput
                  ref={el => (this.to = el)}
                  value={to}
                  placeholder="To"
                  format="L"
                  formatDate={formatDate}
                  parseDate={parseDate}
                  dayPickerProps={{
                    selectedDays: [from, { from, to }],
                    disabledDays: { before: from },
                    modifiers,
                    month: from,
                    fromMonth: from,
                    numberOfMonths: 2,
                    localeUtils: MomentLocaleUtils,
                    locale: this.props.locale,
                    canChangeMonth: true
                    // className: "Selectable"
                  }}
                  onDayChange={this.handleToChange}
                  // showWeekNumbers
                />
                <InputGroup.Addon>
                  <i className="fa fa-calendar" aria-hidden="true" />
                </InputGroup.Addon>{" "}
              </InputGroup>
            </FormGroup>
          </span>
          {/* <span className={this.props.small ? "separator-sm" : "separator"}>
          {" "}
          —{" "}
        </span> */}
          {/* <span onClick={() => this.clearFields()} className="date-clear-btn">
            <i className="fa fa-times" />
          </span> */}
        </div>
      </React.Fragment>
    );
  };
}

export default DateRangePicker;
